import api from "./api";
import type {
  GetCategoriesRequest,
  GetProductsRequest,
  Category,
  Product,
  User,
} from "../types";

class HomeService {
  getCategories(companyCode, restaurantCode) {
    return api().post("/Home/Categories", {
      companyCode,
      restaurantCode,
    });
  }

  getProducts(companyCode, restaurantCode, categoryId) {
    return api().post("/Home/Products", {
      companyCode,
      restaurantCode,
      categoryId,
    });
  }

  uploadProfileImage(formData) {
    return api().post("/Home/UploadProfileImage", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  getAdmin() {
    return api().get("/Home/Admin");
  }
}

export default new HomeService();
